import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                margin: theme.spacing(3),
                flexGrow: 1,
                [theme.breakpoints.down("sm")]: {
                    margin: theme.spacing(2),
                },
            },
        }),
    { name: "LayoutContainer" }
);

export const LayoutContainer = (props: { children?: React.ReactNode }) => {
    const classes = useStyles({});
    return <div className={classes.root}>{props.children}</div>;
};
